// What may follow a game's name in an address (CLAUDE.md: Puzzle identity).
//
// A puzzle number is a whole number from 1 up, written plainly: no letters, no
// zero, no sign, no decimal point, no leading zero, and at most nine digits —
// the database's numbers stop at about two billion, and a longer one would be
// an error from the server rather than "not there". Anything else after
// /running-order/ or /call-sheet/ is an address that does not exist, never
// today's puzzle: "/running-order/abc" used to open the daily.

/** The puzzle number in an address segment, or null if it is not one. */
export function puzzleNumber(segment: string): number | null {
  return /^[1-9][0-9]{0,8}$/.test(segment) ? Number(segment) : null;
}
